import { RoutesEnum } from '../enums'

type ExtractRouteParams<T extends string> =
  T extends `${string}:${infer Param}/${infer Rest}`
    ? { [K in Param | keyof ExtractRouteParams<`/${Rest}`>]: string }
    : T extends `${string}:${infer Param}`
    ? { [K in Param]: string }
    : NonNullable<unknown>

export const getRoute = <T extends RoutesEnum>(
  route: T,
  params?: ExtractRouteParams<T>,
): string => {
  if (!params) return route

  let path = route as string

  Object.keys(params).forEach((key) => {
    path = path.replace(`:${key}`, (params as Record<string, string>)[key])
  })

  return path
}
